<template>
  <DataList
    title="Платники"
    resource="payers"
    :columns="columns"
    :get-items-fn="getPayers"
    :search-label="'Пошук за назвою платника'"
  />
</template>

<script>
import * as payersApi from "../../../backend/payersApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title" },
      { title: "ЄДРПОУ/ІПН", name: "code", dataPath: "code" },
      { title: "Клієнт", name: "client", dataPath: "client.title" },
    ],
  }),
  methods: {
    getPayers(...args) {
      return payersApi.getPayers(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
